import { Link } from "react-router-dom";
import { Calendar, MapPin, ArrowRight } from "lucide-react";
import { optimizeImage } from "../utils/optimizeImage";

const EventCard = ({ event, className = "" }) => {
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" });
  };

  const getEventTypeLabel = (type) => {
    const labels = { summit: "Summit", awards: "Awards Ceremony", forum: "Leadership Forum", conference: "Conference" };
    return labels[type] || type;
  };

  return (
    <Link
      to={`/event/${event.slug}`}
      className={`editorial-card group block ${className}`}
      style={{ border: '1px solid rgba(10,10,10,0.08)' }}
      data-testid={`event-card-${event.slug}`}
    >
      <div className="editorial-image-wrapper aspect-[16/9]">
        <img src={optimizeImage(event.image_url, { width: 800 })} alt={event.title} loading="lazy" decoding="async" className="editorial-card-image" />
        <div className="absolute top-4 left-4">
          <span className="inline-flex items-center px-3 py-1 bg-black text-white text-[0.65rem] font-bold tracking-widest uppercase">
            {getEventTypeLabel(event.event_type)}
          </span>
        </div>
      </div>
      <div className="p-6 space-y-3">
        <h3 className="font-serif text-xl font-semibold text-neutral-950 group-hover:text-wine-700 transition-colors leading-snug">
          {event.title}
        </h3>
        <p className="text-neutral-500 text-sm line-clamp-2 leading-relaxed">
          {event.description}
        </p>
        <div className="flex flex-wrap items-center gap-4 text-neutral-400 text-xs pt-2">
          <div className="flex items-center gap-1.5">
            <Calendar className="w-3.5 h-3.5" />
            <span>{formatDate(event.event_date)}</span>
          </div>
          <div className="flex items-center gap-1.5">
            <MapPin className="w-3.5 h-3.5" />
            <span>{event.location}</span>
          </div>
        </div>
        <div className="flex items-center gap-1.5 text-wine-700 text-xs font-semibold tracking-wide uppercase pt-2 opacity-0 group-hover:opacity-100 transition-opacity">
          Learn More
          <ArrowRight className="w-3.5 h-3.5 group-hover:translate-x-1 transition-transform" />
        </div>
      </div>
    </Link>
  );
};

export default EventCard;
